/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable indent */
import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import $ from 'jquery'
import hash from 'object-hash'
import { Grid } from '@mui/material'

import {
  // -- Projects
  getProject,
  getProjectLocations,
  getProjectWeathers,
  // -- Scenarios
  getScenario,
  getScenarioVariables,
  getScenarioResources,
  getScenarioProducts,
  // getScenarioLocations,
  // getScenarioWeathers,
  getScenarioParameters,
  // -- Flow Groups
  getFlowGroups,
  createFlowGroup,
  updateFlowGroup,
  deleteFlowGroup,
  setCurrentFlowGroup,
  getAlphaFactors,
  setBpmnState
} from '../../actions'
import { ErrorsContext } from '../../contexts'
import { Logger, LoggerTypes } from '../../utils'
import {
  // routePaths,
  // getRoute,
  attributesNames,
  flowTaskGroups,
  userRightTypes,
  bpmnRefreshTypes
} from '../../constants'
import {
  Page,
  PageCenter,
  PageLeft,
  PageRight,
  PageNumSections,
  AccessControl,
  AccessControlNoRights
} from '../../components' // HeaderErrors
import {
  FlowElements,
  FlowListTabs,
  FlowTabs,
  ProjectCard,
  SimulationDialogLaunch,
  SimulationDialogList
} from '../../containers'
import './style.scss'

const BpmnEmptyXMLDiagram = `<?xml version="1.0" encoding="UTF-8"?>
<bpmn2:definitions xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xmlns:bpmn2="http://www.omg.org/spec/BPMN/20100524/MODEL" xmlns:bpmndi="http://www.omg.org/spec/BPMN/20100524/DI" id="sample-diagram" targetNamespace="http://bpmn.io/schema/bpmn" xsi:schemaLocation="http://www.omg.org/spec/BPMN/20100524/MODEL BPMN20.xsd">
  <bpmn2:process id="Process_1" isExecutable="false" />
  <bpmndi:BPMNDiagram id="BPMNDiagram_1">
    <bpmndi:BPMNPlane id="BPMNPlane_1" bpmnElement="Process_1" />
  </bpmndi:BPMNDiagram>
</bpmn2:definitions>`

let numLoaded = 0
let _errorHash = null
// let cacheFlowActionTasks = []
// let cacheFlowActionConditions = []
// let currentFlowGroupIdDeleted = null

export const FlowGroups = () => {
  const params = useParams()
  // const history = useHistory()
  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const childRef = useRef()

  const [isLoading, setIsLoading] = useState(numLoaded === 0)

  // -- Project
  const projects = useSelector((state) => state.projects)

  // -- Scenario + Attributes
  const scenarios = useSelector((state) => state.scenarios)
  const scenarioResources = useSelector((state) => state.scenarioResources) || {}
  const scenarioProducts = useSelector((state) => state.scenarioProducts) || {}
  const scenarioVariables = useSelector((state) => state.scenarioVariables) || {}
  const scenarioLocations = useSelector((state) => state.projectLocations) || {} // /!\ Here it's a Project dependency
  const scenarioWeathers = useSelector((state) => state.projectWeathers) || {} // /!\ Here it's a Project dependency
  const scenarioParameters = useSelector((state) => state.scenarioParameters) || {}

  // -- FlowGroups + Actions + AlphaFactors
  const alphaFactors = useSelector((state) => state.alphaFactors) || {}
  const flowGroups = useSelector((state) => state.flowGroups)

  // const flowConditions = useSelector((state) => state.flowConditions) || {}
  // const flowTasks = useSelector((state) => state.flowTasks) || {}

  // -- Simulations (list and launch)
  const [openDialogSimulationList, setOpenDialogSimulationList] = useState(false)
  const [openDialogSimulationLaunch, setOpenDialogSimulationLaunch] = useState(false)

  // -- current errors on current BPMN tab view
  const [currentErrors, setCurrentErrors] = useState(null)

  if (!projects || !scenarios) {
    Logger.trace(LoggerTypes.WARN, 'FlowGroups.error()', { projects, scenarios })
    return <></>
  }

  const currentProject = projects.currentProject || {}
  const currentScenario = scenarios.currentScenario || {}

  /**
   * Here the `items` represents the contain of each tabs with its inherent errors (if any)
   *
   * Ex: [
   * { creation_date: '2023-01-03', description: '...', errors: Array(0), flows: Array(1), id: 'e086bd00-014e-4d2c-83e9-43e3e32d2511', … }
   * { creation_date: '2022-07-07', description: '...', errors: Array(0), flows: Array(1), id: 'de5fed1f-a035-4229-a417-d86e4f5b3c56', … }
   * { creation_date: '2023-01-03', description: '...', errors: Array(0), flows: Array(1), id: 'f4be2778-641e-48f7-8d77-bf98053db9df', … }
   * ...
   * ]
   */
  const flowGroupItems = flowGroups?.items || []
  flowGroupItems.sort((a, b) => (a.name > b.name ? 1 : -1))

  const currentFlowGroup = flowGroups.currentFlowGroup || null

  /** Here the `flowGroupConditions` represents a map of flowGroup identifiers pointing to their flow conditions
   *
   * Ex: [
   * { "flow_group_id" => [ {"condition.element_id" => Object} ] },
   * { "flow_group_id" => [ {"condition.element_id" => Object}, {"condition.element_id" => Object}, ... ] },
   * { "flow_group_id" => [ ] },
   * ...
   * ]
   */
  const flowGroupConditions = flowGroups?.flowGroupConditions || null

  /** Here the `flowGroupTasks` represents a map of flowGroup identifiers pointing to their flow tasks and instances
   *
   * Ex: [
   * {
   *  "flow_group_A" => [{
   *    instances: => [ {"Activity_05aod7n" => taskInstanceObject_1}, {"Activity_03pmmaq" => taskInstanceObject_2} ],
   *    tasks: => [ {"taskObject_1.id" => [ "taskInstanceObject_1.id", "taskInstanceObject_2.id" ]} ]
   *  }]
   * },
   * {
   *  "flow_group_B" => [{
   *    instances: => [ {"Activity_17ypplk" => taskInstanceObject_3}, {"task_instance.element_id" => taskInstanceObject_4} ],
   *    tasks: => [ {"taskObject_2.id" => [ "taskInstanceObject_3.id" ]}, {"taskObject_3.id" => [ "taskInstanceObject_4.id" ]} ]
   *  }]
   * }
   * ...
   * ]
   */
  const flowGroupTasks = flowGroups?.flowGroupTasks || null

  const pid = params.pid || currentProject.id || null
  const sid = params.sid || currentScenario.id || null
  const fid = params.fid || currentFlowGroup?.id || null

  // -- Scenario's attributes
  const resourceItems = scenarioResources?.items || []
  const productItems = scenarioProducts?.items || []
  const variableItems = scenarioVariables?.items || []
  const locationItems = scenarioLocations?.items || []
  const weatherItems = scenarioWeathers?.items || []
  const parameterItems = scenarioParameters?.items || []

  // -- FlowGroup's Actions + AlphaFactors
  const alphaFactorItems = alphaFactors?.items || []

  Logger.trace(LoggerTypes.CONTAINER, 'FlowGroups() - INIT()', { flowGroups })

  // Build the conditionItems array based on the flowGroupConditions map values
  let conditionItems = []
  if (currentFlowGroup && flowGroups?.flowGroupConditions) {
    flowGroupConditions.get(currentFlowGroup.id).forEach((value) => {
      conditionItems.push(value)
    })
  }

  // Build the list of tasks from all flowGroups and the tasks of the current flowGroup
  // all tasks are needed for the task assign feature where the left panel only requires flowGroup tasks
  let allTasks = new Map([])
  let flowGroupTaskItems = []
  if (flowGroupTasks) {
    flowGroupTasks.forEach((_flowGroup, _flowGroupId) => {
      if (_flowGroupId === currentFlowGroup?.id) {
        flowGroupTaskItems = [..._flowGroup.tasks.values()]
      }
      _flowGroup.tasks.forEach((_task, _taskId) => {
        if (!allTasks.has(_taskId)) {
          allTasks.set(_taskId, _task)
        }
      })
    })
  }
  const allTaskItems = [...allTasks.values()]
  allTaskItems.sort((a, b) => (a.name > b.name ? 1 : -1))
  flowGroupTaskItems.sort((a, b) => (a.name > b.name ? 1 : -1))

  const errorClassName = '__elementError'

  /**
   * Reset BPMN errors handlers
   */
  const _resetErrors = () => {
    _errorHash = null

    if ($('g')) {
      $('g').removeClass(errorClassName)
    }

    if (currentErrors) {
      setCurrentErrors(null)
    }
  }

  /**
   * Assign to each task its group color.
   */
  const _checkTasksGroup = () => {
    if (currentFlowGroup && flowGroupTasks) {
      // currentFlowGroup.flows &&
      // currentFlowGroup.flows.forEach((flow) => {
      //   flow &&
      //   flow.taskInstances &&
      //   flow.taskInstances.forEach((task) => {
      flowGroupTasks.get(currentFlowGroup.id).instances.forEach((task) => {
        const element_id = task?.element_id || null
        const group_name = task?.group_name || null
        if (element_id && group_name) {
          const _el = $(`[data-element-id="${element_id}"] .djs-visual > rect`)
          const group = flowTaskGroups.filter((_group) => _group.value === group_name)
          const color = (group && group[0] && group[0].color) || null
          if (_el && color) {
            // _el.css({ stroke: color, fill: color, 'fill-opacity': 0.15, 'stroke-width': '4px' })
            _el.css({ stroke: color, fill: color, 'fill-opacity': 0.15 })
          }
        }
      })
      // })
    }
  }

  /**
   * While saving a flowGroup, the backend can reply with an array of errors
   * those errors belong to the BPMN XML elements which don't follow certain business rules.
   */
  const _checkXmlErrors = () => {
    if (
      currentFlowGroup &&
      currentFlowGroup?.errors &&
      currentFlowGroup.errors.length > 0
      // ((flowGroups?.errors && flowGroups?.errors.length > 0) ||
      //  (flowGroups?.currentFlowGroup?.errors && flowGroups?.currentFlowGroup?.errors.length > 0))
    ) {
      // const _currentErrors = flowGroups?.currentFlowGroup?.errors || currentErrors // flowGroups.errors ? flowGroups?.errors :
      const _currentErrors = currentFlowGroup?.errors || currentErrors // flowGroups.errors ? flowGroups?.errors :

      if (!_errorHash || _errorHash !== hash(_currentErrors)) {
        _errorHash = hash(_currentErrors)

        Logger.trace(LoggerTypes.WARN, 'FlowGroups._checkXmlErrors()', { _currentErrors, _errorHash })

        setCurrentErrors(_currentErrors)

        // // -- on load get list
        // if (flowGroups?.currentFlowGroup?.errors?.length > 0) {
        //   setTimeout(() => {
        //     flowGroups.currentFlowGroup.errors.forEach(__errorJqueryHandler)
        //   }, 1000)
        // }
      }
    } else {
      _resetErrors()
    }
  }

  const __errorJqueryHandler = (err) => {
    const _el = $(`[data-element-id="${err.element_id}"]`)
    const _elLabel = $(`[data-element-id="${err.element_id}_label"]`)
    if (_el) {
      _el.addClass(errorClassName)
      if (_elLabel) {
        _elLabel.addClass(errorClassName)
      }
    }
  }

  const refreshFlowGroupXML = async (bpmnRefresh) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.refreshFlowGroupXML()', { bpmnRefresh })

    // -- Reload only the flow group of the updated tab to handle the XML changes set on the backend (e.g: xmlns:sbm)
    // await dispatch(getFlowGroup(pid, sid, bpmnRefresh.flowGroup.id)).then(async (res) => {
    //   const flowGroupUpdated = res?.data || null
    //   const _bpmnRefresh = {
    //     ...bpmnRefresh,
    //     flowGroup: flowGroupUpdated
    //   }

    //   // -- Load the inherent elements that could have changed and update the current "tab" FlowGroup
    //   // -- with the data that comes from the back-end.
    //   Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.refreshFlowGroupXML().dispatch(getFlowGroup(...))', {
    //     res,
    //     currentFlowGroup,
    //     flowGroupUpdated: flowGroupUpdated // <-- Data received from the backend
    //   })

    //   if (flowGroupUpdated) {
    // -- Apply BPMN updates
    if (childRef?.current) {
      childRef.current.refreshBpmn(bpmnRefresh, () => {
        setTimeout(() => {
          _checkXmlErrors()
          _checkTasksGroup()
          dispatch(setBpmnState({ isDirty: false }))
        }, 2000)
      })
    }
    //   }
    // })
  }

  const refreshElementsProperties = async (bpmnRefresh) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.refreshElementProperties()', { bpmnRefresh })

    if (childRef?.current) {
      childRef.current.refreshBpmn(bpmnRefresh, () => {
        Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.refreshElementProperties() - DONE')
      })
    }
  }

  // This method can be called each time a FlowTab is updated by a CRUD event (see onTabXXX methods with dispatchTabEvent)
  // or each time the save button of any FlowElementXXXPanel is pressed
  const refreshAfterSave = async (flowGroupUpdated, elementsUpdated) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.refreshAfterSave()', {
      flowGroupUpdated,
      elementsUpdated
    })
    if (flowGroupUpdated && elementsUpdated) {
      Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.refreshAfterSave().refreshElementsProperties()', elementsUpdated)
      refreshElementsProperties({
        type: bpmnRefreshTypes.ELEMENTS,
        elements: elementsUpdated
      })
    } else if (flowGroupUpdated?.xml) {
      // The save button of the flow_group has been pressed
      refreshFlowGroupXML({
        type: bpmnRefreshTypes.FLOW_GROUP,
        flowGroup: flowGroupUpdated
      })
    } else {
      Logger.trace(LoggerTypes.WARN, 'FlowGroups.refreshAfterSave()', 'Nothing to refresh!')
    }
  }

  // -- FlowTabs' for Create/Update methods
  const dispatchTabCreateorUpdate = (flowGroup, onComplete) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.dispatchTabCreateorUpdate()', { flowGroup, onComplete })

    return dispatch(flowGroup.id ? updateFlowGroup(pid, sid, flowGroup) : createFlowGroup(pid, sid, flowGroup))
      .then(async (res) => {
        const action = flowGroup.id ? 'updateFlowGroup' : 'createFlowGroup'
        Logger.trace(LoggerTypes.CONTROLLER, `FlowGroups.useEffect().dispatch(${action}).then()`, {
          flowGroup,
          res,
          onComplete
        })

        if (!res || !res.data || res.data.isAxiosError) {
          enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
        } else {
          // enqueueSnackbar(t('common.api_success'), { variant: 'success' })
          const flowGroupUpdated = res.data
          if (onComplete && typeof onComplete === 'function') {
            onComplete(flowGroupUpdated)
            numLoaded = 0
          }
        }
      })
      .catch((res) => {
        const action = flowGroup.id ? 'updateFlowGroup' : 'createFlowGroup'
        Logger.trace(LoggerTypes.WARN, `FlowGroups.useEffect().dispatch(${action}).catch()`, { res, flowGroup })
        const error = (res && res.response && res.response.data && JSON.stringify(res.response.data)) || ''
        enqueueSnackbar(`${t('common.api_failure')} ${error}`, { variant: 'error' })
      })
  }

  // This method is called when a new FlowTab element is created
  const onTabAdd = (onComplete) => {
    const randomString = Math.random().toString(36).substr(2, 5)
    const newFlowGroup = {
      name: `${t('flowGroups.default_name')} [${randomString}]`,
      description: t('flowGroups.default_description'),
      xml: BpmnEmptyXMLDiagram
    }

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onTabAdd()', { newFlowGroup })
    return dispatchTabCreateorUpdate(newFlowGroup, onComplete)
  }

  // This method is called when the user clicks a FlowTab which is not the active one.
  const onTabChange = (flowGroup) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onTabChange()', { flowGroup })

    // await _setCurrentFlowGroup(flowGroup)
    dispatch(setCurrentFlowGroup(flowGroup))

    // dispatch(getFlowGroups(pid, sid, _currentFlowGroup.id))
    // dispatch(getFlowGroup(pid, sid, _currentFlowGroup.id))
    //   ?.then((res) => {
    //     Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onTabChange.dispatch(getFlowGroup).then()', { res })
    //     setIsLoading(false)
    //   })
    //   .catch((err) => Logger.trace(LoggerTypes.WARN, 'FlowGroups.onTabChange.dispatch(getFlowGroup).catch()', { err }))
  }

  // This method is called each time the save button of a flowTab is pressed (flowGroup save)
  // or when the name of the tab is edited
  const onTabSave = (flowGroup, refreshXML = true) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onTabSave()', { flowGroup, refreshXML })

    // When the save button is pressed we need to refresh the XML, otherwise we don't need
    const onComplete = refreshXML
      ? (flowGroupUpdated) => {
          Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onTabSave().onComplete()', { flowGroupUpdated })
          refreshAfterSave(flowGroupUpdated)
        }
      : null

    dispatchTabCreateorUpdate(flowGroup, onComplete)
  }

  // This method is called each time a flowTab is deleted
  const onTabDelete = (_fid) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onTabDelete()', { pid, sid, fid: _fid })

    if (_fid && _fid.length > 2) {
      // -- We have to store the current flow group ID
      // -- to prevent from loading this current flow group's 'tasks' and 'conditions' in the useEffect(2) below.
      // currentFlowGroupIdDeleted = _fid
      let tabPosition = 0
      flowGroupItems.forEach((item, idx) => {
        if (item.id === _fid) {
          tabPosition = idx
        }
      })
      Logger.trace(LoggerTypes.CONTROLLER, 'TAB_POSITION', { flowGroupItems, tabPosition })

      dispatch(deleteFlowGroup(pid, sid, _fid))
        .then((res) => {
          Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onTabDelete().dispatch(deleteFlowGroup(...)).then()', {
            res
          })

          if (!res || !res.data || res.data.isAxiosError) {
            enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
          } else {
            // -- reload all the flowGroups
            // dispatch(getFlowGroups(pid, sid)).then((allFlows) => {
            //   Logger.trace(
            //     LoggerTypes.CONTROLLER,
            //     'FlowGroups.onDelete().dispatch(deleteFlowGroup(...)).then().dispatch(getFlowGroups(...)).then',
            //     { allFlows }
            //   )
            //   // -- select the first one
            //   const newFlowGroup = (allFlows?.data.length > 0 && allFlows.data[0]?.flow_group) || null
            //   if (newFlowGroup) {
            //     // Reload the page to display another flow group
            //     setUrlPath(newFlowGroup.id)
            //     // _setCurrentFlowGroup(newFlowGroup)
            //   }
            // })
            const newTabId = flowGroupItems[tabPosition === 0 ? 1 : tabPosition - 1]
            onTabChange(newTabId)
          }
        })
        .catch((res) => {
          Logger.trace(LoggerTypes.WARN, 'FlowGroups.useEffect().dispatch(deleteFlowGroup(...)).catch()', { res })
          const error = (res && res.response && res.response.data && JSON.stringify(res.response.data)) || ''
          enqueueSnackbar(`${t('common.api_failure')} ${error}`, { variant: 'error' })
        })
    }
  }

  const onSimulationList = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onSimulationList()', {
      parameters: parameterItems,
      weather_data: weatherItems
    })

    setOpenDialogSimulationList(true)
  }

  const onSimulationLaunch = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.onSimulationLaunch()', {})

    setOpenDialogSimulationLaunch(true)
  }

  // ----

  const loadData = [
    // -- projects
    { dispatch: getProject(pid), methodName: 'getProject' },
    { dispatch: getProjectLocations(pid), methodName: 'getProjectLocations', id: attributesNames.LOCATIONS },
    { dispatch: getProjectWeathers(pid), methodName: 'getProjectWeathers', id: attributesNames.WEATHER_DATA },
    // -- scenarios
    { dispatch: getScenario(pid, sid), methodName: 'getScenario' },
    { dispatch: getScenarioVariables(pid, sid), methodName: 'getScenarioVariables', id: attributesNames.VARIABLES },
    { dispatch: getScenarioResources(pid, sid), methodName: 'getScenarioResources', id: attributesNames.RESOURCES },
    { dispatch: getScenarioProducts(pid, sid), methodName: 'getScenarioProducts', id: attributesNames.PRODUCTS },
    { dispatch: getScenarioParameters(pid, sid), methodName: 'getScenarioParameters', id: attributesNames.PARAMETERS },
    // -- flowGroups
    { dispatch: getFlowGroups(pid, sid), methodName: 'getFlowGroups' },
    { dispatch: getAlphaFactors(), methodName: 'getAlphaFactors' }
  ]

  // -- if we arrive in a page with a flowGroup set as currentFlowGroup
  // -- we load the actions that belong to that flowGroup.
  // Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups - loadData()', {
  //   pid,
  //   sid,
  //   fid
  // })
  // if (pid && sid && fid && String(fid).length > 10) {
  //   loadData.push({ dispatch: getFlowTasks(pid, sid, fid, false), methodName: 'getFlowTasks' })
  //   loadData.push({ dispatch: getFlowConditions(pid, sid, fid, false), methodName: 'getFlowConditions' })
  // }

  useEffect(() => {
    loadData.forEach((_current) => {
      dispatch(_current.dispatch)
        .then(async (res) => {
          Logger.trace(LoggerTypes.CONTROLLER, `FlowGroups.useEffect(1).dispatch(${_current.methodName}()).then()`, {
            projects,
            scenarios,
            res
          })

          if (!res || !res.data || res?.data?.isAxiosError) {
            enqueueSnackbar(t('common.api_failure'), { variant: 'error' })
          }

          // -- if the user arrive for the first time in the flowGroups page,
          // -- there's no flow group (for this `pid` & `sid`) so we create a new one in the back-end.
          if (
            pid &&
            sid &&
            currentFlowGroup === null &&
            _current.methodName === 'getFlowGroups' &&
            res?.data?.length === 0
          ) {
            Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.useEffect(1).dispatch().then() CREATE_FIRST', {
              pid,
              sid,
              flowGroup,
              res
            })

            await onAdd(() => {
              Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.useEffect(1).onAdd() FINISHED !')
            })
            // await onAdd(() => {
            //   getFlowGroups(pid, sid)
            // })
          }

          // -- last API call
          if (numLoaded === loadData.length - 1) {
            // enqueueSnackbar(t('common.api_success'), { variant: 'success' })

            Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.useEffect().dispatch().then() ALL_DONE', {
              pid,
              sid,
              currentFlowGroup,
              methodName: _current.methodName,
              res
            })
            numLoaded = 0
            setIsLoading(false)
          }

          numLoaded++
        })
        .catch((res) => {
          Logger.trace(LoggerTypes.WARN, `FlowGroups.useEffect().dispatch(${_current.methodName}()).catch()`, {
            pid,
            sid,
            projects,
            scenarios,
            res
          })
          const error = (res && res.response && res.response.data && JSON.stringify(res.response.data)) || ''
          enqueueSnackbar(`${t('common.api_failure')} ${error}`, { variant: 'error' })
        })
    })
  }, [])

  // -- on FlowGroup tab change, reload the 'getFlowTasks' and the 'getFlowConditions'
  // useEffect(() => {
  //   if (fid && flowGroup && currentFlowGroupIdDeleted !== fid) {
  //     // -- load and store the current flow `TASKS` in cache.
  //     dispatch(getFlowTasks(pid, sid, fid, true))
  //       .then((res) => {
  //         taskItems = res?.data?.items || null
  //         _taskHash = (taskItems && hash(taskItems)) || null
  //         if (_taskHash && taskItems) {
  //           cacheFlowActionTasks[_taskHash] = taskItems
  //         }

  //         Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.useEffect(2).dispatch(getFlowTasks(...)).then()', {
  //           res,
  //           _taskHash,
  //           taskItems
  //         })
  //       })
  //       .catch((res) => {
  //         Logger.trace(LoggerTypes.WARN, 'FlowGroups.useEffect(2).dispatch(getFlowTasks(...)).catch()', { res })
  //         const error = (res && res.response && res.response.data && JSON.stringify(res.response.data)) || ''
  //         enqueueSnackbar(`${t('common.api_failure')} ${error}`, { variant: 'error' })
  //       })

  //     // -- load and store the current flow `CONDITIONS` in cache.
  //     dispatch(getFlowConditions(pid, sid, fid, true))
  //       .then((res) => {
  //         conditionItems = res?.data?.items || null
  //         _conditionHash = (conditionItems && hash(conditionItems)) || null
  //         if (_conditionHash && conditionItems) {
  //           cacheFlowActionConditions[_conditionHash] = conditionItems
  //         }

  //         Logger.trace(LoggerTypes.CONTROLLER, 'FlowGroups.useEffect(2).dispatch(getFlowTasks(...)).then()', {
  //           res,
  //           _conditionHash,
  //           conditionItems
  //         })
  //       })
  //       .catch((res) => {
  //         Logger.trace(LoggerTypes.WARN, 'FlowGroups.useEffect(2).dispatch(getFlowConditions(...)).catch()', { res })
  //         const error = (res && res.response && res.response.data && JSON.stringify(res.response.data)) || ''
  //         enqueueSnackbar(`${t('common.api_failure')} ${error}`, { variant: 'error' })
  //       })

  //     Logger.trace(LoggerTypes.PAGE, 'FlowGroups.useEffect(TAB CHANGED)', {
  //       cacheFlowActionTasks,
  //       cacheFlowActionConditions
  //     })
  //   }
  // }, [fid, flowGroup])

  // if (_taskHash && !cacheFlowActionTasks[_taskHash] && taskItems) {
  //   cacheFlowActionTasks[_taskHash] = taskItems
  // }

  // if (_conditionHash && !cacheFlowActionConditions[_taskHash] && conditionItems) {
  //   cacheFlowActionConditions[_conditionHash] = conditionItems
  // }

  /**
   * When all the API calls are done, initialize default values fo:
   *  - All available tabs.
   *  - Selected tab + `currentFlowGroup` global object.
   *  - Default BPMN XML.
   */
  // const _init = async () => {
  //   if (!isLoading) {
  // -- initialize default values for the tabs.
  // -- define at least one by default
  // allFlowGroups =
  //   flowGroupItems &&
  //   flowGroupItems.map((el, i) => {
  //     return el.flow_group
  //       ? // -- from get list
  //         {
  //           ...el.flow_group,
  //           id: `${el.flow_group.id ? el.flow_group.id : i}`,
  //           name: el.flow_group.name ? el.flow_group.name : `${t('flowGroups.default_name')} ${i > 0 ? i : ''}`,
  //           description: el.flow_group.description
  //             ? el.flow_group.description
  //             : t('flowGroups.default_description'),
  //           xml: el.flow_group.xml ? el.flow_group.xml : BpmnEmptyXMLDiagram,
  //           errors: el.errors
  //         }
  //       : // -- from create
  //         {
  //           ...el.flow_group,
  //           id: `${el.id ? el.id : i}`,
  //           name: el.name ? el.name : `${t('flowGroups.default_name')} ${i > 0 ? i : ''}`,
  //           description: el.flow_group.description
  //             ? el.flow_group.description
  //             : t('flowGroups.default_description'),
  //           xml: el.xml ? el.xml : BpmnEmptyXMLDiagram,
  //           errors: el.errors
  //         }
  //   })

  // -- estimate the current flow group to select
  // allFlowGroups = flowGroupItems
  // const _fidFlowGroup = allFlowGroups.filter((el) => el.id === fid)[0] || null
  // currentFlowGroup = flowGroup ? flowGroup : fid && _fidFlowGroup ? _fidFlowGroup : allFlowGroups[0]

  //     if (!currentFlowGroup && !isLoading) {
  //       Logger.trace(LoggerTypes.PAGE, 'FlowGroups._init()', {
  //         fid,
  //         flowGroupItems,
  //         currentFlowGroup
  //       })

  //       await _setCurrentFlowGroup(currentFlowGroup)
  //     }
  //   }
  // }

  // _init()

  if (!isLoading) {
    Logger.trace(LoggerTypes.PAGE, 'FlowGroups.render()', {
      numLoaded,
      currentErrors,
      project: { currentProject },
      scenario: {
        sid,
        currentScenario,
        attributes: {
          resourceItems,
          productItems,
          variableItems,
          locationItems,
          weatherItems,
          parameterItems
        },
        scenarioWeathers
      },
      flowGroup: {
        flowGroups,
        fid,
        currentFlowGroup,
        flowGroupItems
      },
      flowActions: {
        alphaFactorItems,
        allTaskItems,
        flowGroupTaskItems,
        conditionItems
      }
    })

    // -- we have to use a setTimeout here because the BPMN element takes time to render
    // -- and the CSS to apply to it are processed by JQuery, so we need the page to be fully rendered.
    setTimeout(() => {
      _checkXmlErrors()
      _checkTasksGroup()

      setTimeout(() => {
        // -- on load get list
        if (currentErrors?.length > 0) {
          currentErrors.forEach(__errorJqueryHandler)
        }
      }, 10)
    }, 10)
  }

  return (
    (!isLoading && currentFlowGroup && (
      // flowGroups.errors ? flowGroups?.errors : flowGroups?.currentFlowGroup?.errors
      // flowGroups?.currentFlowGroup?.errors
      <ErrorsContext.Provider value={currentErrors}>
        {/* -- Header Errors -- */}
        {/* <HeaderErrors /> */}

        <Page className="flows">
          <PageRight className="close">
            <AccessControl userPermissions={[userRightTypes.SCENARIO_READ]} renderNoAccess={() => <></>}>
              {!isLoading && (
                <FlowElements
                  currentProject={currentProject}
                  currentScenario={currentScenario}
                  currentFlowGroup={currentFlowGroup}
                  // -- Scenario's Attributes
                  resourceItems={resourceItems}
                  productItems={productItems}
                  variableItems={variableItems}
                  locationItems={locationItems}
                  weatherItems={weatherItems}
                  parameterItems={parameterItems}
                  // -- FlowGroup's actions
                  alphaFactorItems={alphaFactorItems}
                  taskItems={allTaskItems}
                  conditionItems={conditionItems}
                  refreshAfterSave={refreshAfterSave}
                />
              )}
            </AccessControl>
          </PageRight>

          <PageCenter numSections={PageNumSections.TWO_SECTIONS} className="close">
            <AccessControl
              userPermissions={[userRightTypes.SCENARIO_READ]}
              renderNoAccess={() => <AccessControlNoRights />}
            >
              <FlowTabs
                ref={childRef}
                isLoading={isLoading}
                flowGroups={flowGroups}
                currentFlowGroup={currentFlowGroup}
                onTabAdd={onTabAdd}
                onTabChange={onTabChange}
                onTabSave={onTabSave}
                onTabDelete={onTabDelete}
                onSimulationList={onSimulationList}
                onSimulationLaunch={onSimulationLaunch}
              />
            </AccessControl>
          </PageCenter>

          <PageLeft>
            <AccessControl userPermissions={[userRightTypes.SCENARIO_READ]} renderNoAccess={() => <></>}>
              {!isLoading && currentProject && currentScenario ? (
                <Grid item={true} xs={true}>
                  <div id="lateralPaper">
                    <div className="lateral">
                      <ProjectCard currentProject={currentProject} />
                      <FlowListTabs
                        currentProject={currentProject}
                        currentScenario={currentScenario}
                        currentFlowGroup={currentFlowGroup}
                        flowGroups={flowGroupItems}
                        loadData={loadData}
                        // -- inherit of Project's Scenario's Attributes
                        resourceItems={resourceItems}
                        productItems={productItems}
                        variableItems={variableItems}
                        locationItems={locationItems}
                        weatherItems={weatherItems}
                        parameterItems={parameterItems}
                        // -- FlowGroup's actions
                        taskItems={flowGroupTaskItems}
                        conditionItems={conditionItems}
                      />
                    </div>
                  </div>
                </Grid>
              ) : (
                <></>
              )}
            </AccessControl>
          </PageLeft>
          {openDialogSimulationList && (
            <SimulationDialogList
              setOpenDialog={setOpenDialogSimulationList}
              currentProject={currentProject}
              currentScenario={currentScenario}
              parameters={parameterItems}
              variables={variableItems}
              resources={resourceItems}
            />
          )}
          {openDialogSimulationLaunch && (
            <SimulationDialogLaunch
              currentProject={currentProject}
              currentScenario={currentScenario}
              parameters={parameterItems}
              variables={variableItems}
              resources={resourceItems}
              setOpenDialog={setOpenDialogSimulationLaunch}
            />
          )}
        </Page>
      </ErrorsContext.Provider>
    )) || <div></div>
  )
}
